export default function SortByDate({ changesDisplay, orderBy, setOrderBy }) {
  return (
    <>
      {/* Toggle disabling the button when user sorts */}
      <div className="text-sm font-semibold flex flex-row flex-wrap items-center">
        <div className="mr-2">Sort by:</div>
        <button
          className="ui-btn-hyperlink font-semibold"
          // aria-controls={`${changesDisplay}`}
          onClick={() => setOrderBy("newest")}
          disabled={orderBy === "newest"}
        >
          Newest
        </button>
        <div className="mx-1">|</div>
        <button
          className="ui-btn-hyperlink font-semibold"
          // aria-controls={`${changesDisplay}`}
          onClick={() => setOrderBy("oldest")}
          disabled={orderBy === "oldest"}
        >
          Oldest
        </button>
      </div>
    </>
  );
}
